import type { TAnyObject } from '@/types/object'
import { defineComponent, type ComponentOptionsBase } from 'vue'

export const component = <PropsType extends TAnyObject = TAnyObject>(
  fun: ComponentOptionsBase<PropsType, any, any, any, any, any, any, any>['setup'],
  props: string[]
) => {
  const c = defineComponent({
    setup: fun
  } as any)
  ;(c as any).props = props
  return c
}
